export default {"src":"/_next/static/media/csgo.d17111de.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};